import Axios, { AxiosResponse } from 'axios';
import { RewistaTobaccoService } from '@/services/rewistaTobaccoService';
import { RewistaTokens } from '@/customTypes';
export default class TokenService extends RewistaTobaccoService {
    public async axiosLogin(username: string, password: string): Promise<boolean> {
        const response = await this.axiosLoginRequest(username, password);
        if (response.status !== 200) {
            return false;
        }
        this.axiosLoginStatus(response.data);
        return true;
    }
    public async axiosLogout(): Promise<boolean> {
        const response = await this.axiosLogoutRequest();
        this.axiosLogoutStatus();
        if (response.status !== 200) {
            return false;
        }
        return false;

    }
    private async axiosLoginRequest(username: string, password: string): Promise<AxiosResponse<RewistaTokens>> {
        return await this.axios.post<RewistaTokens>('token/Login', {
            Login: username,
            Password: password,
        });
    }
    private async axiosLogoutRequest()  {
        return await this.axios.post<string>('token/Logout');
    }
}
